module.exports = __webpack_public_path__ + "img/pic25.9b134ae6.png";